import { DynamicIppicaNewsModal } from 'features/ippica/components/ippicaNewsModal/IppicaNewsModal';
import { IppicaNewsResponseApi } from 'lib/api/ippica/ippicaNewsResponseApi';
import { format } from 'date-fns';
import styles from './IppicaBreakingNewsCard.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useState } from 'react';

export type IppicaBreakingNewsCardProps = {
  item: IppicaNewsResponseApi;
};

export const IppicaBreakingNewsCard = ({ item }: IppicaBreakingNewsCardProps) => {
  const [modalNews, setModalNews] = useState<{
    isOpen: boolean;
    item?: IppicaNewsResponseApi;
  }>({ isOpen: false, item: undefined });

  const labelLeggiDiPiu = useGetLabelByKey('leggi-di-piu');

  return (
    <div className={styles.container}>
      <div>
        <span className={styles.date}>{format(new Date(item.date), 'MM:ss')}</span>
        {item.descrizioneRiunione && <span> - {item.descrizioneRiunione}</span>}
      </div>
      <div className={styles.content}>
        <span dangerouslySetInnerHTML={{ __html: item.title }} suppressHydrationWarning />
        <button className={styles.button} onClick={() => setModalNews({ isOpen: true, item })}>
          {labelLeggiDiPiu}
        </button>
      </div>
      {modalNews.isOpen && (
        <DynamicIppicaNewsModal
          item={modalNews.item}
          isOpen={modalNews.isOpen}
          handleClose={() => setModalNews({ isOpen: false, item: undefined })}
        />
      )}
    </div>
  );
};
